export const MUSIC_LIBRARY_SLICE_TYPE = 'music_library';

export enum MUSIC_LIBRARY_VARIABLES {
  accentColor = '--accent-color',
  titleColor = '--title-color',
  titleWeight = '--title-weight',
  categoryTextColor = '--category-text-color',
  categoryHighlightTextColor = '--category-highlight-text-color',
  trackContainerColor = '--track-container-color',
  trackNameColor = '--track-name-color',
  trackGenresColor = '--track-genres-color',
  iconColor = '--icon-color',
  indicatorBackgroundColor = '--indicator-background--color',
  progressBarColor = '--progress-bar-color',
  selectBackgroundColor = '--select-background-color',
  selectTextColor = '--select-text-color',
  selectActiveTextColor = '--select-active-text-color',
}
